import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useTranslation } from '../utils/i18n-utils';

interface ReportData {
  id: number;
  date: Date;
  customer: string;
  total: number;
  items: number;
}

const Reports: React.FC = () => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [reportType, setReportType] = useState<string>('sales');
  const [reportData, setReportData] = useState<ReportData[]>([]);

  const handleGenerateReport = () => {
    // TODO: Implement report generation logic
    console.log('Generate report');
  };

  const handleExportReport = () => {
    // TODO: Implement export logic
    console.log('Export report');
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {t('reports.title') || 'Reports'}
      </Typography>

      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, sm: 4 }}>
        <FormControl fullWidth>
              <InputLabel>{t('reports.reportType') || 'Report Type'}</InputLabel>
              <Select
                value={reportType}
                label={t('reports.reportType') || 'Report Type'}
                onChange={(e) => setReportType(e.target.value)}
              >
                <MenuItem value="sales">{t('reports.salesReport') || 'Sales Report'}</MenuItem>
                <MenuItem value="inventory">{t('reports.inventoryReport') || 'Inventory Report'}</MenuItem>
                <MenuItem value="customers">{t('reports.customerReport') || 'Customer Report'}</MenuItem>
                <MenuItem value="products">{t('reports.productReport') || 'Product Report'}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label={t('common.startDate') || 'Start Date'}
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                slotProps={{ textField: { fullWidth: true } }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label={t('common.endDate') || 'End Date'}
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                slotProps={{ textField: { fullWidth: true } }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid size={12}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant="contained"
                onClick={handleGenerateReport}
              >
                {t('reports.generateReport') || 'Generate Report'}
              </Button>
              <Button
                variant="outlined"
                onClick={handleExportReport}
              >
                {t('common.export') || 'Export to CSV'}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ p: 2 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('sales.date') || 'Date'}</TableCell>
                <TableCell>{t('customer.name') || 'Customer'}</TableCell>
                <TableCell align="right">{t('sales.total') || 'Total'}</TableCell>
                <TableCell align="right">{t('sales.items') || 'Items'}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reportData.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>
                    {row.date.toLocaleDateString()}
                  </TableCell>
                  <TableCell>{row.customer}</TableCell>
                  <TableCell align="right">
                    د.ل{row.total.toFixed(2)}
                  </TableCell>
                  <TableCell align="right">{row.items}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default Reports; 